import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const ActivateLicense = ({ open, cancel, activate }) => {
  const [email, setEmail] = React.useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <Dialog open={open} onClose={cancel}>
      <DialogTitle>Attivazione nuova licenza</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Inserisci l'indirizzo email del tuo cliente e invia l'invito. Il tuo
          cliente riceverà una mail con un link per completare l'attivazione
          dell'account.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Indirizzo email"
          type="email"
          fullWidth
          variant="standard"
          value={email}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel}>Annulla</Button>
        <Button variant="contained" onClick={() => activate(email)}>
          Attiva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivateLicense;
